enum SitemapType {
  Default = 'default',
  Gate = 'gate',
  Zone = 'zone',
}

export default SitemapType
